/**
 * Hosts that may show operator-preview screens (Card Attempts).
 *
 * Production is fail-closed. A host missing from this set hides those screens.
 * Staging custom domain and its CloudFront default name are both listed
 * because operators open both.
 */
const PREVIEW_HOSTS: ReadonlySet<string> = new Set([
  'localhost',
  '127.0.0.1',
  'staging.frontdeskcollect.ai',
  'd2loedqirvjahl.cloudfront.net',
])

export function isPreviewFrontend(
  hostname: string = globalThis.location.hostname,
): boolean {
  return PREVIEW_HOSTS.has(hostname)
}
